// Formulário genérico de painel (o `form()` do mock) e confirmação (`confirmAction()`).
import { useOverlay } from "./overlay";

const LONG = /descrição|motivo|mudar|exemplo|comentário|ajudaria/i;

export function useFormPanel() {
  const { openPanel, closePanel, toast } = useOverlay();
  return {
    /** Abre um formulário; `onSubmit` recebe os valores na ordem dos campos. */
    form(title: string, fields: string[], message: string, onSubmit?: (values: string[]) => void | Promise<void>) {
      openPanel(
        title,
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const values = [...new FormData(e.currentTarget).values()].map(String);
            await onSubmit?.(values);
            closePanel();
            toast(message);
          }}
        >
          {fields.map((f, i) => (
            <label key={f} style={{ display: "block" }}>
              {f}
              {LONG.test(f) ? (
                <textarea required name={`f${i}`} />
              ) : (
                <input required name={`f${i}`} type={/e-mail/i.test(f) ? "email" : "text"} />
              )}
            </label>
          ))}
          <button className="primary" type="submit">
            Confirmar
          </button>
        </form>,
      );
    },
    confirm(title: string, body: string, message: string, onConfirm?: () => void | Promise<void>) {
      openPanel(
        title,
        <>
          <p>{body}</p>
          <div className="callout">
            Nenhuma alteração é publicada diretamente em produção. A Iuvo avalia e aprova antes da liberação.
          </div>
          <button
            className="primary"
            onClick={async () => {
              await onConfirm?.();
              closePanel();
              toast(message);
            }}
          >
            Confirmar e enviar para avaliação
          </button>
        </>,
      );
    },
  };
}
